// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useEffect, useRef} from 'react';
import cn from 'classnames';
import {format_sa2025_local_date, SA2025_FREE_WATCH_TIME_DAYS,
    use_membership_confirmation} from './use_sa2025';

import styles from './styles.module.less';

interface i_membership_confirmation_props {
    token: string;
    hola_uid: string;
    days: number;
    on_confirmed: ()=>void;
    on_error: (error_type: string)=>void;
}

export const Membership_confirmation = (
    props: i_membership_confirmation_props)=>{
    const {on_confirm_membership} = use_membership_confirmation(props);
    const redemption_started = useRef(false);
    useEffect(()=>{
        if (redemption_started.current)
            return;
        redemption_started.current = true;
        on_confirm_membership();
    }, []);
    const today = format_sa2025_local_date();
    return <div className={cn(styles.refund_page)}>
      <div className={cn(styles.content)}>
        <div className={cn(styles.heading)}>
          Class action settlement in CA (Dist. - TA) 62567-02-22.
        </div>
        <div className={cn(styles.greeting)}>
          Dear Hola user,
        </div>
        <div className={cn(styles.body)}>
          Beginning on {today}, you are entitled to
          {' '}{SA2025_FREE_WATCH_TIME_DAYS} days of free use of the Hola
          Watch Time package, subject and according to the terms of this
          benefit on Hola's website, and in accordance with the class action
          settlement in CA (Dist. - TA) 62567-02-22.
        </div>
        <div className={cn(styles.support)}>
          For any issue please contact support at{' '}
          <a href="mailto:support@hola.org"
            className={cn(styles.support_link)}>
            support@hola.org
          </a>
        </div>
      </div>
    </div>;
};
